import { gql } from 'graphql-request'

export const BUY_EBOOK = gql`
  mutation BuyEbook($buyEbookInput: BuyEbookInput!) {
    buyEbook(buyEbookInput: $buyEbookInput) {
      transactionId
    }
  }
`
